import { useMutation } from '@tanstack/react-query';
import type { AgentApiSharedJobPostSyncRequestsItem } from '@/types/serializers';
import compact from '@/utils/compact';
import type { SyncRequestSearchConditions } from '../lib/pickSyncRequestSearchConditions';

export type { SyncRequestSearchConditions };

type CreateParams = {
  searchConditions: SyncRequestSearchConditions;
  jobSourceId: number;
};

export default function useCreateSharedJobPostSyncRequest() {
  const token = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || '';

  return useMutation({
    mutationFn: async ({
      searchConditions,
      jobSourceId,
    }: CreateParams): Promise<AgentApiSharedJobPostSyncRequestsItem> => {
      const response = await fetch('/agent/api/shared_job_post_sync_requests', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          job_source_id: jobSourceId,
          search_conditions: compact(searchConditions),
        }),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => null);
        throw new Error(data?.message || '取り込みリクエストに失敗しました');
      }
      return response.json();
    },
  });
}
